import { useEffect, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { partnersWidgetInViewport } from '@cred/react-analytics/events'
import { fireGtmEvent } from 'utils/gtm'
import WidgetContext from 'components/widget-context'
import Snowplow from '@cred/react-analytics/Snowplow'
import { withSnowplowContexts, SnowplowReactContext } from '@cred/react-analytics/SnowplowContextManager'

const ViewportAnalytics = ({ seen, trackSnowplowEvent, position, size }) => {
  const widgetContext = useContext(WidgetContext),
    snowplowContext = useContext(SnowplowReactContext),
    [pageviewFired, setPageviewFired] = useState(false),
    [inViewportFired, setInViewportFired] = useState(false)

  useEffect(() => {
    // Wait for size and position data and fire the event only once
    if (size.h && (position.x || position.y) && seen && !inViewportFired) {
      setInViewportFired(true)
      trackSnowplowEvent(partnersWidgetInViewport, {})
      fireGtmEvent('partnerWidgetInViewport', widgetContext)
    }
  }, [seen, position.x, position.y, size.h, inViewportFired, widgetContext])

  useEffect(() => {
    // Wait for the widget size data and fire only once
    if (size.h && !pageviewFired) {
      setPageviewFired(true)
      Snowplow.trackPageView(document.title, snowplowContext, {
        pageUrl: window.location.href,
        referrerUrl: document.referrer,
        shouldActivateExperimentContext: false,
      })
      fireGtmEvent('pageview', widgetContext)
    }
  }, [size.h, pageviewFired, snowplowContext, widgetContext])

  return null
}

ViewportAnalytics.propTypes = {
  seen: PropTypes.bool.isRequired,
  size: PropTypes.object.isRequired,
  position: PropTypes.object.isRequired,
  trackSnowplowEvent: PropTypes.func.isRequired,
}

export default withSnowplowContexts(ViewportAnalytics)
